import { useQuery } from "@tanstack/react-query";
import { CircleHelp } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

/** What logins_explain answers (crm-sites). The paragraph is what staff read; the facts are for agents. */
export interface SignInExplanation {
  contact_id: number;
  summary: string;
  has_password: boolean;
  locked_until?: string;
  sites: { site: string; name: string; member: boolean; can_sign_in: boolean; reason: string }[];
}

/** "Why can't they sign in?": one paragraph for the Club, courses and Manager Training. Reads only: it sends,
 *  changes and clears nothing (a sign-in link is "Send login link"; a lock is Unlock on the Sign-ins card). */
export function SignInExplainDialog({ contactId, onClose }: { contactId: number; onClose: () => void }) {
  const q = useQuery({
    queryKey: ["logins-explain", contactId],
    queryFn: () => api<SignInExplanation>(`/api/v1/logins/explain/${contactId}`),
    retry: false,
    staleTime: 0,
  });
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogTitle>
          <CircleHelp className="mr-1 inline size-4" /> Why can't they sign in?
        </DialogTitle>
        <DialogDescription>The Club, courses and Manager Training, from what the CRM knows now. Nothing was changed or sent.</DialogDescription>
        {q.isLoading && <p className="text-sm text-[var(--color-muted-foreground)]">Checking…</p>}
        {q.error && <p className="text-sm text-[var(--color-destructive)]">{(q.error as Error).message}</p>}
        {q.data && <p className="text-sm leading-relaxed">{q.data.summary}</p>}
      </DialogContent>
    </Dialog>
  );
}
